import { exists } from '@/api'

export interface BatchReserveCancelListCondition {
  cancelDateFrom: string
  cancelDateTo: string
  branchType: string
  branchCode: string
  hasReceiveWaiting: boolean
  hasReturnWaiting: boolean
  reserveCancelReason: string
}

export function BatchReserveCancelListConditionFromJSON(
  json: any
): BatchReserveCancelListCondition {
  const _json = JSON.parse(json)

  return {
    cancelDateFrom: exists(_json, 'cancel_date_from')
      ? _json.cancel_date_from
      : '',
    cancelDateTo: exists(_json, 'cancel_date_to') ? _json.cancel_date_to : '',
    branchType: exists(_json, 'branch_type') ? _json.branch_type : '1',
    branchCode: exists(_json, 'branch_code') ? _json.branch_code : '',
    hasReceiveWaiting: exists(_json, 'has_receive_waiting')
      ? _json.has_receive_waiting
      : false,
    hasReturnWaiting: exists(_json, 'has_return_waiting')
      ? _json.has_return_waiting
      : false,
    reserveCancelReason: exists(_json, 'reserve_cancel_reason')
      ? _json.reserve_cancel_reason
      : ''
  }
}
